import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { isEqual, union, get, isEmpty } from 'lodash';
import Promise from 'bluebird';
import * as JsSearch from 'js-search';
import { camelCaseToTitleCase } from '../../../../helpers/camelCaseToTitleConverter';
import LabelsGrid from '../labelsGrid/LabelsGrid';
import BatchLabelsService from '../../../../../services/BatchLabelsService';
import * as ActionTypes from '../../../../../constants/ActionTypes';

class LabelsSearchProvider extends Component {
    constructor(props) {
        super(props);
        this.updatePromise = Promise.resolve();
        this.state = {
            searchIndex: ''
        }
    }

    getTokenizer = () => {
        const splitSpacesRegex = /\s+/;
        return {
            tokenize: text => text.split(splitSpacesRegex).filter(t => !isEmpty(t))
        };
    };

    getData(chainId, hotelId, level, languages) {
        this.updatePromise.cancel();

        const originalValuePromise = BatchLabelsService.getExplicit(chainId, hotelId, level, languages);
        const higherOrderPromise = BatchLabelsService.getHigherOrder(chainId, hotelId, level, languages);

        this.updatePromise = Promise.all([higherOrderPromise, originalValuePromise]).then(
            ([higherOrderLabels, originalValues]) => {
                this.props.setOriginalLabels(originalValues);
                this.props.setHigherOrderLabels(higherOrderLabels);
                this.props.setCurrentValues(originalValues);

                const searchIndex = new JsSearch.Search('label');
                searchIndex.tokenizer = this.getTokenizer();
                searchIndex.addIndex('label');
                searchIndex.addIndex('value');
                searchIndex.addIndex('key');
                //build search index
                const entries = Object.entries(higherOrderLabels);
                if (entries.length > 0) {
                    const langKeys = entries.map(entry => entry[0]);
                    const labelKeys = union.apply(
                        null,
                        entries.map(entry => Object.keys(entry[1]))
                    );

                    searchIndex.addDocuments(
                        labelKeys.map(labelKey => {
                            const valueMultiIndex = langKeys
                                .map(langKey => {
                                    const higherLevelValue = get(higherOrderLabels, [langKey, labelKey]);
                                    return get(originalValues, [langKey, labelKey], higherLevelValue);
                                })
                                .join(' ');
                            const split = labelKey.split('.');
                            return {
                                label: split.map(camelCaseToTitleCase).join(' '),
                                value: valueMultiIndex,
                                key: labelKey
                            };
                        })
                    );

                    this.setState({ searchIndex })
                }
            }
        );
    }

    componentDidMount() {
        const { chainId, hotelId, level, languages } = this.props;
        this.getData(chainId, hotelId, level, languages);
    }

    componentDidUpdate(prevProps) {
        const { chainId, hotelId, level, languages } = this.props;
        if (
            !isEqual(prevProps.languages, languages) ||
            prevProps.chainId !== chainId ||
            prevProps.hotelId !== hotelId ||
            prevProps.level !== level
        ) {
            this.getData(chainId, hotelId, level, languages);
        }
    }

    render() {
        const { search, languages, hasAccess, selectedTab } = this.props;
        const { searchIndex } = this.state;
        const allLabelsSearch = searchIndex ? searchIndex.search(search) : [];
        const labelsSearch = allLabelsSearch.filter(item => {
            if (selectedTab === 'in-context') {
                return item.key && item.key.startsWith('shs-sbem');
            } else {
                return item.key && !item.key.startsWith('shs-sbem');
            }
        });

        return (
            <LabelsGrid
                labelsSearch={labelsSearch}
                selectedLanguages={languages}
                hasAccess={hasAccess}
                inContextBeta={this.props.inContextBeta}
            />
        );
    }
}

LabelsSearchProvider.propTypes = {
    chainId: PropTypes.string,
    hasAccess: PropTypes.object.isRequired,
    hotelId: PropTypes.string,
    selectedTab: PropTypes.string,
    languages: PropTypes.array,
    search: PropTypes.string.isRequired,
    setCurrentValues: PropTypes.func,
    setHigherOrderLabels: PropTypes.func,
    setOriginalLabels: PropTypes.func,
    inContextBeta: PropTypes.bool
}

LabelsSearchProvider.defaultProps = {
    search: '',
    languages: [],
    selectedTab: 'hosted'
}

const mapStateToProps = state => ({
    level: state.app.selected.level,
    chainId: state.app.selected.chain.Id,
    hotelId: state.app.selected.selectedHotel.id,
    currentValue: state.app.search.labels.originalValue,
    inContextBeta: get(state, 'app.selected.inContextBeta')
});

const mapDispatchToProps = dispatch => ({
    setHigherOrderLabels: labels => dispatch({ type: ActionTypes.SET_HIGHERORDER_LABELS_BATCH, value: labels }),
    setOriginalLabels: labels => dispatch({ type: ActionTypes.SET_ORIGINALVALUES_LABELS_BATCH, value: labels }),
    setCurrentValues: labels => dispatch({ type: ActionTypes.SET_CURRENTVALUE_LABELS_BATCH, value: labels }),
    updateLabel: (key, value) => dispatch({ type: ActionTypes.SET_ORIGINALVALUES_LABELS_BATCH, key, value })
});

export default connect(mapStateToProps, mapDispatchToProps)(LabelsSearchProvider);



// WEBPACK FOOTER //
// ./src/components/pages/pages/search/provider/LabelsSearchProvider.js